import { useEffect, useState } from "react";
import en from "@/data/en";

let current = localStorage.getItem("fbwm_lang") || "it";
const listeners = new Set();

export const getLang = () => current;
export const setLang = (l) => { current = l; localStorage.setItem("fbwm_lang", l); document.documentElement.lang = l; listeners.forEach((fn) => fn(l)); };
export const useLang = () => {
  const [lang, set] = useState(current);
  useEffect(() => { listeners.add(set); return () => listeners.delete(set); }, []);
  return { lang, setLang };
};

export const t = (s, vars) => {
  let out = current === "en" ? (en[s] ?? s) : s;
  if (vars) Object.entries(vars).forEach(([k, v]) => { out = out.replaceAll(`{${k}}`, v); });
  return out;
};
export const locale = () => (current === "en" ? "en-GB" : "it-IT");
